import React from "react";
import classNames from "classnames";
import "./PanelButton.scss";

const PanelButton = (props) => {
  let buttonClassName = classNames({
    "panel-button": true,
    "button-visible": !!props.title,
    "button-direction-up": !props.collapsed
  });

  return (
    <div
      id={props.id}
      title={props.title}
      className={buttonClassName}
      onClick={props.onClick}
      aria-expanded={props.hide}
    ></div>
  );
};

export default PanelButton;
